import { Dispatch, ReactNode, SetStateAction } from 'react'

import { useTranslation } from 'next-i18next'

import Tooltip from '~/components/Tooltip'

import SVGIcon from '../Icons/svgs/SVGIcon'
import TimesBoldIcon from '../Icons/svgs/TimesBoldIcon'
import { Checkbox } from '../Checkbox'
import { Button } from '../Button'

import { ArrowPosition, TooltipWidth } from './Tooltip.types'

interface TipsTooltipProps {
  children: ReactNode
  arrowPosition?: ArrowPosition
  width?: TooltipWidth
  hideTooltip: boolean | undefined
  setTooltipClose: Dispatch<SetStateAction<boolean>>
  isChecked: boolean
  setChecked: Dispatch<SetStateAction<boolean>>
  handleOkButtonOnClick: () => void
  hideCheckbox?: boolean
}
export default function TipsTooltip(props: TipsTooltipProps): React.ReactElement {
  const {
    children,
    arrowPosition = 'bottom-center-high',
    width = 'normal',
    hideTooltip,
    setTooltipClose,
    isChecked,
    setChecked,
    handleOkButtonOnClick,
    hideCheckbox = false,
  } = props

  const { t } = useTranslation('generics')

  const onCloseButtonClick = (): void => {
    setTooltipClose((prevState) => !prevState)
  }

  return (
    <div>
      <Tooltip
        arrowPosition={arrowPosition}
        borderColor="border-blue-medium"
        showBorder
        showTooltip={!hideTooltip}
        width={width}
      >
        <button aria-label={t('close')} className="absolute scale-golden right-2 -mt-2" onClick={onCloseButtonClick}>
          <SVGIcon icon={TimesBoldIcon} pathClassName="text-purple" size={30} />
        </button>

        {children}
        <div className="flex justify-center items-center sm360:gap-4 md:gap-8 -mb-4">
          {!hideCheckbox && (
            <div>
              <Checkbox
                centerText
                checkboxClassName="w-6 h-6"
                checkboxOuterClassName="w-6 h-6"
                id="learning-path-tooltip"
                isBgWhite
                isChecked={isChecked}
                onChange={setChecked}
                text={t("don'tShowAgain")}
                textPosition="right"
                textSizeMobileView="medium"
              />
            </div>
          )}
          <div className="flex items-center pb-3">
            <Button onClick={handleOkButtonOnClick}>Ok</Button>
          </div>
        </div>
      </Tooltip>
    </div>
  )
}
